import { MfaRequiredError, type LoginOutcome, type SiteChoiceOption } from "@lumora/bridge";

export type SignInResult =
  | { kind: "signedIn"; site?: string }
  | { kind: "choose"; sites: SiteChoiceOption[] }
  /** Two-step sign-in is on: collect a code and call `mfaChallenge` with this token (#1501). */
  | { kind: "mfa"; mfaToken: string; site?: string };

export interface SignInTransport {
  loginWithSiteChoice(input: { site?: string; email: string; password: string }): Promise<LoginOutcome>;
}

/**
 * One login attempt. `site` is set only when re-submitting from the "Choose a site" step.
 * The password is passed through, never stored or logged here.
 */
export async function attemptSignIn(
  client: SignInTransport,
  input: { email: string; password: string; site?: string },
): Promise<SignInResult> {
  let res: LoginOutcome;
  try {
    res = await client.loginWithSiteChoice({
      email: input.email,
      password: input.password,
      ...(input.site ? { site: input.site } : {}),
    });
  } catch (err) {
    if (err instanceof MfaRequiredError) {
      return { kind: "mfa", mfaToken: err.mfaToken, ...(err.site ? { site: err.site } : {}) };
    }
    throw err;
  }
  if ("requiresSiteChoice" in res) {
    return { kind: "choose", sites: res.sites };
  }
  return res.site ? { kind: "signedIn", site: res.site } : { kind: "signedIn" };
}
